import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getScheduledMedicationReminders } from "../../utils/medicationSchedule";

const DAILY_CARE_LOG_PATH = "/daily-care-log";

const MedicationReminders = ({
  medicationOptions = [],
  administrationHistory = [],
  isLoading = false,
}) => {
  const [showAll, setShowAll] = useState(false);

  const sortedMedications = getScheduledMedicationReminders(
    medicationOptions,
    administrationHistory,
  );
  const prnCount = medicationOptions.filter(
    (med) => med.status === "PRN",
  ).length;

  if (isLoading) {
    return (
      <p className="text-sm text-slate-500">Loading medication reminders...</p>
    );
  }

  if (sortedMedications.length === 0) {
    return (
      <div className="rounded-2xl bg-slate-50 p-4 text-center">
        <p className="text-sm text-slate-500">
          No active medication reminders for today.
        </p>
        {prnCount > 0 && (
          <p className="text-xs text-slate-500 mt-1">
            {prnCount} PRN medication{prnCount === 1 ? "" : "s"} available as
            needed.
          </p>
        )}
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Add Daily Care Log →
        </Link>
      </div>
    );
  }

  const visibleMedications = showAll
    ? sortedMedications
    : sortedMedications.slice(0, 2);
  const hasMore = sortedMedications.length > 2;

  return (
    <div>
      <ul className="grid grid-cols-1 gap-3">
        {visibleMedications.map((med) => (
          <li key={med.id}>
            <Link
              to={DAILY_CARE_LOG_PATH}
              className="block rounded-2xl border border-emerald-100 bg-emerald-50/70 p-4 transition hover:bg-white hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <p className="font-semibold text-slate-950">
                {med.medicationName}{" "}
                <span className="text-sm font-normal text-slate-500">
                  ({med.strength})
                </span>
              </p>
              <p className="mt-1 text-sm text-slate-500">
                Next dose: {med.nextDose.toLocaleString()}
              </p>
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-500">
          PRN medications are not scheduled reminders.
        </p>
        {hasMore ? (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            {showAll ? "Show Less" : `View All (${sortedMedications.length}) →`}
          </button>
        ) : null}
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Open Daily Care Log →
        </Link>
      </div>
    </div>
  );
};

export default MedicationReminders;
